import React, { useContext, useEffect } from 'react';
import { Row, Col, Image } from '@thd-olt-component-react/core-ui';
import { useLocation, useParams } from '@thd-olt-component-react/router';
import { observer } from 'mobx-react-lite';
import { JobPostingContent } from '../../../../components/JobPostings/JobPostingContent/JobPostingContent';
import { JobPostingSideBar } from '../../../../components/JobPostings/JobPostingSideBar/JobPostingSideBar';
import { JobPostingContext } from '../../../../contexts/JobPostingContext';
import { useStore } from '../../../../store';
import JobPostingNotification from './JobPostingNotification';
import JobPostingDetailsLoader from './JobPostingDetailsLoader';
import { generateImageSource } from '../../../../utils/generateImageSource';
import CandidateViewUrl from '../../../../components/CandidateViewUrl/CandidateViewUrl';

export const JobPostingDetails = observer(() => {
  const {
    jobPostingNotificationsStore: { jobPostingUpdatedNotificationVisible }
  } = useStore();

  const {
    getJobPosting, toggleEditorMode, editorModeActive, isJobPostingFetching, activeJobPosting
  } = useContext(JobPostingContext);
  const { pathname } = useLocation();
  const { jobPostingId } = useParams();

  useEffect(() => {
    fetchJobPosting();
  }, []);

  async function fetchJobPosting() {
    await getJobPosting(jobPostingId);
  }

  useEffect(() => {
    handleEditorMode(pathname);
  }, [pathname]);

  if (isJobPostingFetching || Object.keys(activeJobPosting).length === 0) {
    return (
      <JobPostingDetailsLoader />
    );
  }

  return (
    <>
      <div className="ptp-job-posting__page-wrapper">
        <Row>
          <Col sm={2} xs={2} md={2} lg={2} fallback={6}>
            <div className="ptp-job-posting__sub-title">
              <Image
                src={generateImageSource('/images/v1/path-to-pro/posting-details-icon.svg')}
                className="ptp-job-posting__posting-details-icon"
              />
              Posting Details
            </div>
          </Col>
          <Col sm={10} xs={10} md={10} lg={10} fallback={6}>
            {editorModeActive && (
              <div className="ptp-job-posting__edit-watermark">
              EDITING POSTING
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col sm={3} xs={12}>
            <JobPostingSideBar />
            <CandidateViewUrl />
          </Col>
          <Col sm={9} xs={12}>
            <JobPostingContent />
          </Col>
        </Row>
      </div>
      <JobPostingNotification
        visible={jobPostingUpdatedNotificationVisible}
        title="Job Posting Has Been Updated"
        text="We have saved your updates."
      />
    </>
  );

  function handleEditorMode(path) {
    if (path?.includes('edit') && !editorModeActive) {
      toggleEditorMode();
    }
  }
});
